export { type CtaProps, default } from './Cta';
